// export const Base_Url = "http://127.0.0.1:8000";
export const Base_Url = "https://ihrtierartz.ch";
// export const Base_Url = "https://vetmidi.org";
